class NotifyButton extends HTMLElement {
  constructor() {
    super();
    this.bis_form = null;
    this.modal_close = null;
    this.success_message = null;
    this.success_close = null;
    this.bis_form_inner = null;
    this.variant_id = this.getAttribute("data-variant-id") || 12345;
  }

  connectedCallback() {
    
    this.initializeElements();
    this.attachEventListeners();
  }

  initializeElements() {
    this.bis_form = document.getElementById("bis-form");
    this.modal_close = document.getElementById("modal-close");
    this.success_message = document.getElementById("success_message");
    this.success_close = document.getElementById("success-close");
    this.bis_form_inner = document.getElementById("bis-form-inner");
  }

  attachEventListeners() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.bis_form.style.display = "flex";
    });

    // Close modal with X button
    this.modal_close.addEventListener("click", (e) => {
      e.preventDefault();
      this.bis_form.style.display = "none";
    });

    // Close modal by clicking outside
    this.bis_form.addEventListener("click", (e) => {
      if (e.target === this.bis_form) {
        this.bis_form.style.display = "none";
      }
    });

    // Close success message
    this.success_close.addEventListener("click", (e) => {
      this.success_message.style.display = "none";
    });

    // Close success message by clicking outside
    this.success_message.addEventListener("click", (e) => {
      if (e.target === this.success_message) {
        this.success_message.style.display = "none";
      }
    });

    // Handle form submission
    this.bis_form_inner.addEventListener("submit", (event) => {
      event.preventDefault();
      this.handleFormSubmission();
    });
  }

  async handleFormSubmission() {
    const customer_email = document.getElementById("bis_input").value;

    const options = {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        revision: "2025-01-15",
        "content-type": "application/vnd.api+json",
      },
      body: `{
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "channels": ["EMAIL"],
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "email": "${customer_email}"
                }
              }
            }
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::${this.variant_id}"
              }
            }
          }
        }
      }`,
    };

    const url =
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QQEyaB";

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        this.showError({
          title: "Network Error",
          detail: "Please try again later.",
        });
        return;
      }

      this.bis_form.style.display = "none";
      this.success_message.style.display = "flex";
    } catch (err) {
      console.error("Network Error:", err);
      this.showError({
        errors: [{ title: "Network Error", detail: "Please try again later." }],
      });
    }
  }
  showError(errorData) {
    this.bis_form.style.display = "none";

    // Create or update error message
    let errorModal = document.getElementById("error_message");
    if (!errorModal) {
      const errorHTML = `
          <div id="error_message" class="hide">
            <div class="error-container">
                <h3 class="error-title">Error</h3>
                <p id="error-text"></p>
                <button type="button" id="error-close">OK</button>
            </div>
          </div>
       `;
      document.body.insertAdjacentHTML("beforeend", errorHTML);
      errorModal = document.getElementById("error_message");

      // Add close event listener
      document.getElementById("error-close").addEventListener("click", () => {
        errorModal.style.display = "none";
      });

      errorModal.addEventListener("click", (e) => {
        if (e.target === errorModal) {
          errorModal.style.display = "none";
        }
      });
    }

    // Update error message
    const errorText = document.getElementById("error-text");
    if (errorData.errors && errorData.errors[0]) {
      const error = errorData.errors[0];
      errorText.textContent = `${error.title}: ${error.detail}`;
    } else {
      errorText.textContent = "An unexpected error occurred. Please try again.";
    }

    errorModal.style.display = "flex";
  }
}

if (!customElements.get("notify-button")) {
  customElements.define("notify-button", NotifyButton);
}
